import type { Service } from "../types";
import {
  OutdoorAdvertisingIcon,
  HoardingIcon,
  SignageIcon,
  BrandingIcon,
  FlexPrintingIcon,
  RetailBrandingIcon,
} from "../components/icons/ServiceIcons";

export const services: Service[] = [
  {
    id: "outdoor-advertising",
    number: "01",
    title: "Outdoor Advertising",
    description: "High-visibility advertising across strategic outdoor spaces.",
    Icon: OutdoorAdvertisingIcon,
  },
  {
    id: "hoardings-billboards",
    number: "02",
    title: "Hoardings & Billboards",
    description: "Large-format advertising built to capture attention.",
    Icon: HoardingIcon,
  },
  {
    id: "signage",
    number: "03",
    title: "Signage",
    description: "Clear, professional signage for businesses and spaces.",
    Icon: SignageIcon,
  },
  {
    id: "indoor-outdoor-branding",
    number: "04",
    title: "Indoor & Outdoor Branding",
    description: "Consistent branding across physical environments.",
    Icon: BrandingIcon,
  },
  {
    id: "flex-printing-banners",
    number: "05",
    title: "Flex Printing & Banners",
    description: "Large-format printing for campaigns, events and promotions.",
    Icon: FlexPrintingIcon,
  },
  {
    id: "retail-business-branding",
    number: "06",
    title: "Retail & Business Branding",
    description: "Physical brand experiences that help businesses stand out.",
    Icon: RetailBrandingIcon,
  },
];
